var map = {
	"./Stroke 1.png": 965,
	"./Why Our Save the Dat.png": 966,
	"./all_about_shipping@2x.png": 967,
	"./ask_for_everything@2x.png": 968,
	"./big-day@1x.png": 492,
	"./big-day@2x.png": 493,
	"./birds@1x.png": 969,
	"./birds@2x.png": 970,
	"./check-list@1x.png": 521,
	"./check-list@2x.png": 522,
	"./circle-better@1x.png": 971,
	"./circle-better@2x.png": 972,
	"./empty_rsvp.png": 973,
	"./empty_rsvp2x.png": 974,
	"./envelope.png": 523,
	"./envelope.svg": 975,
	"./envelope@2x.png": 976,
	"./events_doodle.png": 223,
	"./events_doodle.svg": 977,
	"./gifts@1x.png": 978,
	"./gifts@2x.png": 979,
	"./guest-list@1x.png": 481,
	"./guest-list@2x.png": 482,
	"./guest.png": 980,
	"./guest.svg": 981,
	"./guest2x.png": 982,
	"./guest_approved@2x.png": 983,
	"./invitations@1x.png": 494,
	"./invitations@2x.png": 495,
	"./invites_paper.svg": 984,
	"./invites_paper@1x.png": 524,
	"./invites_paper@2x.png": 525,
	"./laptop-one-heart.png": 985,
	"./laptop-one-heart@2x.png": 986,
	"./laptop@1x.png": 987,
	"./laptop@2x.png": 988,
	"./long-page-checklist.png": 989,
	"./long-page-checklist@2x.png": 990,
	"./make_it_personal@2x.png": 991,
	"./namecard-with-name.png": 992,
	"./namecard-with-name@2x.png": 993,
	"./namecard_no_name.svg": 397,
	"./namecard_with_name.svg": 994,
	"./namecard_with_question_marks.svg": 102,
	"./no_address.png": 995,
	"./no_address2x.png": 996,
	"./onboarding_1.png": 398,
	"./onboarding_1@2x.png": 399,
	"./onboarding_2.png": 997,
	"./onboarding_2@2x.png": 998,
	"./onboarding_3.png": 400,
	"./onboarding_3@2x.png": 401,
	"./onboarding_4.png": 999,
	"./onboarding_4@2x.png": 1000,
	"./red-star-left@1x.png": 483,
	"./red-star-left@2x.png": 484,
	"./red-star-right@1x.png": 485,
	"./red-star-right@2x.png": 486,
	"./registry_publish_champagne.svg": 1001,
	"./rsvp@1x.png": 496,
	"./rsvp@2x.png": 497,
	"./save-the-date@1x.png": 498,
	"./save-the-date@2x.png": 499,
	"./sparkle-left.svg": 526,
	"./sparkle-right.svg": 527,
	"./sparkle-up.svg": 528,
	"./ta-da.png": 1002,
	"./ta-da@2x.png": 1003,
	"./talk.svg": 1004,
	"./talk@1x.png": 500,
	"./talk@2x.png": 501,
	"./timeline-line-dark@1x.png": 502,
	"./timeline-line-dark@2x.png": 503,
	"./timeline-line@1x.png": 1005,
	"./timeline-line@2x.png": 1006,
	"./tips.svg": 1007,
	"./underline_long@1x.png": 453,
	"./underline_long@2x.png": 454,
	"./underline_sm@1x.png": 469,
	"./underline_sm@2x.png": 470,
	"./website_publish_confetti.svg": 402,
	"./wedding-websites@1x.png": 529,
	"./wedding-websites@2x.png": 530,
	"./wedding_help.png": 531,
	"./wedding_help.svg": 1008,
	"./wedding_help@2x.png": 1009
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 222;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 222
// module chunks = 44